import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardBody } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

// actions
import { getStaffProfile } from "store/auth/staffprofile/actions";

class FinanceAdminSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
  }

  componentDidMount() {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    this.props.getStaffProfile(this.state.user_id);

    setTimeout(() => {
      if (this.props.success) {
        this.setState({ name: this.props.success.name });
      }
    }, 1500);
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  render() {
    return (
      <div
        className="position-fixed top-0 start-0 w-100 vh-100 d-flex align-items-center justify-content-center overflow-hidden"
        style={{ backgroundColor: "#92c1e4" }} // ✅ PAGE BACKGROUND COLOR
      >
        {/* Decorative white circles */}
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 50, height: 50, top: "5%", left: "5%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 80, height: 80, top: "15%", right: "10%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 60, height: 60, top: "30%", left: "20%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 100, height: 100, top: "40%", right: "20%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 40, height: 40, top: "55%", left: "10%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 70, height: 70, top: "65%", right: "30%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 90, height: 90, bottom: "15%", left: "35%" }}
        />
        <div
          className="position-absolute rounded-circle bg-white"
          style={{ width: 60, height: 60, bottom: "5%", right: "15%" }}
        />

        {/* ✅ CENTER CARD */}
        <Card
          className="rounded-4 p-1 mt-5 border-0 text-white"
          style={{
            maxWidth: 600,
            width: "100%",
            backgroundColor: "#0055e9", // ✅ CARD BACKGROUND COLOR
            zIndex: 2,
          }}
        >
          <CardBody className="text-center">
            <h1
              className="fw-bold text-uppercase mb-4 text-white"
              style={{ fontSize: "32px" }}
            >
              {this.state.name}, <br />
              Welcome to Login
            </h1>
            <p
              className="mb-0 lh-lg"
              style={{ fontSize: "16px", opacity: 0.95 }}
            >
              Your role belongs to CSR in which you can Add New Participants
              (which will be Associate with your organization), and do Approvels
              also you can make that Participants Payments.
              {/* You can create and update Rounds and News. */}
              <br />
              <b>To know more</b>, please visit upper <b>Navbar / Menubar</b>.
            </p>
          </CardBody>
        </Card>

        {/* Bottom Semi Circle */}
        <div
          className="position-absolute bottom-0 start-50 translate-middle-x"
          style={{
            width: 120,
            height: 60,
            backgroundColor: "#022e4b",
            borderTopLeftRadius: 120,
            borderTopRightRadius: 120,
          }}
        />
      </div>
    );
  }
}

FinanceAdminSummary.propTypes = {
  success: PropTypes.any,
  getStaffProfile: PropTypes.func,
};

const mapStateToProps = state => {
  const { success } = state.StaffProfile;
  return { success };
};

export default withRouter(
  connect(mapStateToProps, { getStaffProfile })(
    withTranslation()(FinanceAdminSummary)
  )
);
